import React from 'react';

import { FormattedMessage } from 'react-intl';

import Lozenge from '@atlaskit/lozenge';
import { StatsigFeatureKeys } from '@atlassian/bitbucket-features';

import { useStatsigGate } from 'src/contexts/feature-provider';

import { STALE_CRITERIA_DAYS } from '../route';

import messages from './branch-kind-lozenges.i18n';
import * as styles from './branch-kind-lozenges.styled';

type Props = {
  branchName: string;
  development: string;
  main: string;
  production: string;
  daysOld: number;
  merged: boolean;
  isLoading: boolean;
  staleFilterSelected: boolean;
};

const BranchKindLozenges = ({
  branchName,
  main,
  production,
  development,
  daysOld,
  merged,
  isLoading,
  staleFilterSelected,
}: Props) => {
  const lozenges = [];

  if (main === branchName) {
    lozenges.push(<FormattedMessage {...messages.branchKindLozengeMain} />);
  }

  if (development === branchName) {
    lozenges.push(
      <FormattedMessage {...messages.branchKindLozengeDevelopment} />
    );
  }

  if (production === branchName) {
    lozenges.push(
      <FormattedMessage {...messages.branchKindLozengeProduction} />
    );
  }

  const staleBranchFeatureEnabled = useStatsigGate(
    StatsigFeatureKeys.staleBranchesFilter
  );
  const branchIsStale =
    staleBranchFeatureEnabled &&
    daysOld > STALE_CRITERIA_DAYS &&
    branchName !== main &&
    branchName !== development &&
    branchName !== production &&
    merged &&
    !staleFilterSelected &&
    !isLoading;
  if (branchIsStale) {
    lozenges.push(<FormattedMessage {...messages.branchKindLozengeStale} />);
  }

  return lozenges.length > 0 ? (
    <styles.OuterContainer>
      {lozenges.map((lozenge, index) => {
        const isStaleLozenge =
          (lozenge as unknown as FormattedMessage).props.id ===
          messages.branchKindLozengeStale?.id;
        return (
          <styles.InnerContainer key={index}>
            <Lozenge appearance={isStaleLozenge ? 'moved' : 'default'}>
              {lozenge}
            </Lozenge>
          </styles.InnerContainer>
        );
      })}
    </styles.OuterContainer>
  ) : null;
};

export default BranchKindLozenges;
